import {_} from "vue-underscore";
import api from "../utils/api.js";
import { trackEvent } from '../utils/tracking';

const cart_uri = api.cartUri();

export const cart = {
    namespaced: true,
    state: {
        cartProducts: [],
        cartOutfits: [],
        lastSuccessCartId: 0,
        checkoutProvider: 'shopify',
        loadingStatus: false,
    },
    getters: {
        getCartProducts(state) {
            return state.cartProducts;
        },
        cartProductsCount(state) {
            let cartCount = 0;

            Object.keys(state.cartOutfits).forEach(key => {
                cartCount += _.keys(state.cartOutfits[key])
                    .filter((itemKey) => itemKey !== 'date')
                    .reduce((count, itemKey) => count += new Number(state.cartOutfits[key][itemKey]['cart_product_quantity']), 0);
            });

            return cartCount;
        },
        getCartTotal(state) {
            var cartOutfits = state.cartOutfits;

            let cartTotal = 0;
            _.each(cartOutfits, outfit => {
                _.each(outfit, (cartProduct, key) => {
                    if(key == 'date') return;
                    cartTotal += cartProduct.product_price * cartProduct.cart_product_quantity;
                });
            });

            return cartTotal;
        },
        getCartOutfits(state) {
            /* Transform return object to have size and color option value ids */
            _.each(state.cartOutfits, outfit => {
                Object.keys(outfit).forEach(key => {
                    if(key == 'date') return;
                    outfit[key].product_option_value_ids_color = [];
                    _.each(
                        outfit[key].product_option_values,
                        product_option_value => {
                            product_option_value.product_option_token === "size"
                                ? (outfit[key].product_option_value_id_size =
                                product_option_value.product_option_value_id)
                                : outfit[key].product_option_value_ids_color.push(
                                product_option_value.product_option_value_id
                            );
                        }
                    );
                });
            });

            //console.log(state.cartOutfits);

            return state.cartOutfits;
        },
        getCheckoutProvider(state) {
            return state.checkoutProvider;
        },
        getLoadingStatus(state) {
            return state.loadingStatus;
        },
        getLastSuccessCartId(state) {
            return state.lastSuccessCartId;
        }
    },
    mutations: {
        deleteProductFromCart(state, payload) {
            state.cartOutfits[payload.outfitKey] = _.omit(state.cartOutfits[payload.outfitKey], payload.productKey);
        },
        updateCartProductQuantity(state, payload) {
            state.cartProducts[payload.productKey].transaction_item_quantity =
                payload.quantity;
        },
        setCartOutfits(state, payload) {
            state.cartOutfits = payload.response;
            //console.log("cart outfits:", state.cartOutfits);
        },
        setCheckoutProvider(state, payload) {
            state.checkoutProvider = payload.response;
        },
        resetState(state){
            state.cartProducts = [];
            state.cartOutfits = [];
        },
        setLoadingStatus(state, status) {
            state.loadingStatus = status;
        },
        setLastSuccessCartId(state, payload) {
            state.lastSuccessCartId = payload.cartId || 0;
        },
        resetLastSuccessCartId(state) {
            state.lastSuccessCartId = 0;
        },
        saveSuccessCart(state, payload) {
            state.lastSuccessCartId = payload.cart_id || 0;
            trackEvent("purchase", payload.tracking_data || {});
        }
    },
    actions: {
        fetchCartProducts(context) {
            return api
                .get(cart_uri)
                .then(response => {
                    context.commit("setCartOutfits", {
                        response: response.cart.outfits
                    });
                    context.commit("setCheckoutProvider", {
                        response: response.cart.checkout_provider
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        },
        insertProductsToCart(context, payload) {
            let items = [];
            let { user } = payload;
            
            if(!user) {
                user = context.rootGetters['auth/getUser'];
            }

            _.each(payload.products, product => {

                if (product.selected) {

                    let product_option_value_ids = [
                        product.product_option_value_id_color || product.product_option_value_id,
                    ];

                    if(product.product_option_value_id_size){
                        product_option_value_ids.push(product.product_option_value_id_size);
                    }

                    let item = {
                        product_option_value_ids,
                        product_id: product.product_id,
                        cart_product_quantity: product.transaction_item_quantity || 1,
                        outfit_id: product.outfit_id,
                        user_id: user.user_id
                    };

                    items.push(item);
                }
            });

            if (items.length) {
                console.log('adding items to cart:', items);

                context.commit('setLoadingStatus', true);

                return api
                    .post(cart_uri, {items: items})
                    .then(response => {
                        context.commit("setCartOutfits", {
                            response: response.body.cart.outfits
                        });
                        context.commit("setCheckoutProvider", {
                            response: response.body.cart.checkout_provider
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        throw error;
                    })
                    .finally(() => {
                        context.commit('setLoadingStatus', false);
                    });
            }
        },
        updateCartProduct(context, payload) {

            let product = payload.product;

            let uri = cart_uri + product.cart_product_id;

            let product_option_value_ids = [
                product.product_option_value_id,
            ];

            if(product.product_option_value_id_size){
                product_option_value_ids.push(product.product_option_value_id_size);
            }

            let item = {
                user_id: payload.user.user_id,
                product_id: product.product_id,
                cart_product_quantity: product.cart_product_quantity,
                outfit_id: product.outfit_id,
                product_option_value_ids
            };

            return api
                .post(uri, {item: item})
                .then(response => {
                    console.log('updated:', response);
                    context.commit("setCartOutfits", {
                        response: response.body.cart.outfits
                    });
                    context.commit("setCheckoutProvider", {
                        response: response.body.cart.checkout_provider
                    });
                })
                .catch(error => {
                    console.log(error);
                    throw error;
                });
        },
        deleteProductFromCart(context, payload) {
            let uri = cart_uri + payload.id;
            return api
                .delete(uri)
                .then(response => {
                    context.commit("setCartOutfits", {
                        response: response.body.cart.outfits
                    });
                    context.commit("setCheckoutProvider", {
                        response: response.body.cart.checkout_provider
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        },
        archiveActiveCart(context) {
            return api
                .post(cart_uri + 'archive')
                .then(response => {
                    context.commit('resetState');

                    context.commit('cart/saveSuccessCart', response.body);
                })
                .catch(error => {
                    console.log(error);
                    throw error.body.message;
                });
        }
    }
};
